import { render, staticRenderFns } from "./IdManagerRetireMergeId.vue?vue&type=template&id=e95c1070&scoped=true&"
import script from "./IdManagerRetireMergeId.vue?vue&type=script&lang=js&"
export * from "./IdManagerRetireMergeId.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerRetireMergeId.vue?vue&type=style&index=0&id=e95c1070&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95c1070",
  null
  
)

export default component.exports